import { getInitials } from './assigneeSelectorHelpers';

interface AssigneeAvatarProps {
    name: string;
    /** Background color/paint - the caller picks it (hashed per-name, or the
     *  translucent white overlay an active menu row uses instead). */
    color: string;
    /** `md` is the trigger's size; `sm` is the in-menu row size. */
    size: AssigneeAvatarSize;
}

export type AssigneeAvatarSize = 'sm' | 'md';

const SIZE_CLASSES: Record<AssigneeAvatarSize, string> = {
    sm: 'w-5 h-5 text-[9px]',
    md: 'w-7 h-7 text-[10px]'
};

/** The colored, initials-filled circle both the trigger and menu rows use. */
export function AssigneeAvatar({ name, color, size }: AssigneeAvatarProps) {
    return (
        <div
            className={`${SIZE_CLASSES[size]} rounded-full flex items-center justify-center font-bold text-white flex-shrink-0 shadow-sm`}
            style={{ backgroundColor: color }}
        >
            {getInitials(name)}
        </div>
    );
}

/** The dashed "+" circle that stands in for the avatar when nobody is assigned. */
export function UnassignedAvatar({ size }: { size: AssigneeAvatarSize }) {
    return (
        <div
            className={`${SIZE_CLASSES[size]} rounded-full border-2 border-dashed border-gray-300 flex items-center justify-center flex-shrink-0 group-hover:border-gray-400 transition-colors`}
        >
            <svg
                className="w-3 h-3 text-gray-400 group-hover:text-gray-500"
                viewBox="0 0 12 12"
                fill="none"
            >
                <path
                    d="M6 2.5V9.5M2.5 6H9.5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        </div>
    );
}
